import PropTypes from 'prop-types';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Toolbar, Tooltip, IconButton, Typography, OutlinedInput, InputAdornment, Button } from '@mui/material';
// component
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

const StyledRoot = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1, 0, 3),
}));

const StyledSearch = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  '&.Mui-focused': {
    width: 320,
    boxShadow: theme.customShadows.z8,
  },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${alpha(theme.palette.grey[500], 0.32)} !important`,
  },
}));

// -----------------------------------------------------------------------

UserListToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func,
  refreshFunction: PropTypes.func,
  showSearchButton: PropTypes.bool,
  onSearch: PropTypes.func,
};

export default function UserListToolbar({
  numSelected,
  filterName,
  onFilterName,
  refreshFunction,
  onSearch,
  showSearchButton = false,
}) {
  return (
    <StyledRoot
      sx={{
        ...(numSelected > 0 && {
          color: 'primary.main',
          bgcolor: 'primary.lighter',
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
      ) : (
        <div>
          <StyledSearch
            value={filterName}
            onChange={onFilterName}
            placeholder="Buscar"
            startAdornment={
              <InputAdornment position="start">
                <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled', width: 20, height: 20 }} />
              </InputAdornment>
            }
          />
          {showSearchButton && (
            <Button variant="contained" color="primary" style={{ marginLeft: '10px' }} onClick={onSearch}>
              Buscar
            </Button>
          )}
        </div>
      )}

      {numSelected > 0 ? (
        <Tooltip title="Share">
          <IconButton>
            <Iconify icon="material-symbols:ios-share-rounded" />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Refresh">
          <IconButton onClick={refreshFunction}>
            <Iconify icon="material-symbols:refresh" />
          </IconButton>
        </Tooltip>
      )}
    </StyledRoot>
  );
}
